import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createElementVNode as _createElementVNode, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, vModelText as _vModelText, withDirectives as _withDirectives, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveDynamicComponent as _resolveDynamicComponent, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

const _withScopeId = n => (_pushScopeId("data-v-7cd0b449"), n = n(), _popScopeId(), n);

const _hoisted_1 = {
  class: "personalInformation"
};
const _hoisted_2 = {
  class: "img_box"
};
const _hoisted_3 = {
  class: "img"
};
const _hoisted_4 = {
  class: "list_box"
};

const _hoisted_5 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "昵称", -1));

const _hoisted_6 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "绑定手机", -1));

const _hoisted_7 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "邮箱账号", -1));

const _hoisted_8 = {
  class: "liet_item"
};

const _hoisted_9 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "邀请码", -1));

const _hoisted_10 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, null, -1));

const _hoisted_11 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "修改密码", -1));

const _hoisted_12 = {
  class: "dialog_content"
};
const _hoisted_13 = {
  class: "title"
};
const _hoisted_14 = ["placeholder"];
const _hoisted_15 = {
  class: "details_page"
};
const _hoisted_16 = {
  key: 0,
  class: "head_title"
};
const _hoisted_17 = {
  class: "title"
};
const _hoisted_18 = {
  class: "cont_body"
};
const _hoisted_19 = {
  class: "dialog_content"
};

const _hoisted_20 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "title"
}, "填写个人邮箱", -1));

const _hoisted_21 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "text"
}, " 为了防止账号丢失，且便于推荐新片，请设置您的邮箱地址，现在设置有机会免费空降福利姬哦！~ ", -1));

const _hoisted_22 = {
  class: "dialog_content"
};

const _hoisted_23 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "title"
}, "填写手机号", -1));

const _hoisted_24 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "text"
}, " 为了防止账号丢失，且便于推荐新片，请设置您的手机号，绑定手机可每日免费看5部电影！~ ", -1));

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_my_image = _resolveComponent("my-image");

  const _component_van_uploader = _resolveComponent("van-uploader");

  const _component_van_icon = _resolveComponent("van-icon");

  const _component_van_popup = _resolveComponent("van-popup");

  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createVNode(_component_van_uploader, {
    "after-read": $setup.afterRead
  }, {
    default: _withCtx(() => [_createElementVNode("div", _hoisted_3, [(_openBlock(), _createBlock(_component_my_image, {
      key: $setup.fileUrl,
      url: $setup.fileUrl
    }, null, 8, ["url"]))])]),
    _: 1
  }, 8, ["after-read"])]), _createElementVNode("div", _hoisted_4, [_createElementVNode("div", {
    class: "liet_item",
    onClick: _cache[0] || (_cache[0] = $event => $setup.toDetails('nc'))
  }, [_hoisted_5, _createElementVNode("div", null, [_createElementVNode("span", null, _toDisplayString($setup.userInfo.nickname || $setup.userInfo.username), 1), _createVNode(_component_van_icon, {
    name: "arrow"
  })])]), _createElementVNode("div", {
    class: "liet_item",
    onClick: _cache[1] || (_cache[1] = $event => !$setup.userInfo.phone ? $setup.bindPhone() : '')
  }, [_hoisted_6, _createElementVNode("div", null, [_createElementVNode("span", null, _toDisplayString($setup.userInfo.phone || "请绑定手机"), 1), _createVNode(_component_van_icon, {
    name: "arrow"
  })])]), _createElementVNode("div", {
    class: "liet_item",
    onClick: _cache[2] || (_cache[2] = $event => !$setup.userInfo.email ? $setup.bindEmail() : '')
  }, [_hoisted_7, _createElementVNode("div", null, [_createElementVNode("span", null, _toDisplayString($setup.userInfo.email || "请绑定邮箱账号"), 1), _createVNode(_component_van_icon, {
    name: "arrow"
  })])]), _createElementVNode("div", _hoisted_8, [_hoisted_9, _createElementVNode("div", null, [_hoisted_10, _createVNode(_component_van_icon, {
    name: "arrow"
  })])]), _createElementVNode("div", {
    class: "liet_item",
    onClick: _cache[3] || (_cache[3] = $event => $setup.toDetails('mm'))
  }, [_hoisted_11, _createElementVNode("div", null, [_createVNode(_component_van_icon, {
    name: "arrow"
  })])])]), _createElementVNode("div", {
    class: "btn",
    onClick: _cache[4] || (_cache[4] = (...args) => $setup.toLogin && $setup.toLogin(...args))
  }, "更换绑定"), _createVNode(_component_van_popup, {
    show: $setup.showDialog,
    "onUpdate:show": _cache[7] || (_cache[7] = $event => $setup.showDialog = $event),
    round: ""
  }, {
    default: _withCtx(() => [_createElementVNode("div", _hoisted_12, [_createElementVNode("div", _hoisted_13, _toDisplayString($setup.popupText), 1), _withDirectives(_createElementVNode("input", {
      "onUpdate:modelValue": _cache[5] || (_cache[5] = $event => $setup.pupupValue = $event),
      type: "text",
      placeholder: `请输入${$setup.popupText}`
    }, null, 8, _hoisted_14), [[_vModelText, $setup.pupupValue]]), _createElementVNode("div", {
      class: "btns",
      onClick: _cache[6] || (_cache[6] = (...args) => $setup.okBtns && $setup.okBtns(...args))
    }, "确认")])]),
    _: 1
  }, 8, ["show"]), _createVNode(_component_van_popup, {
    show: $setup.showDetailsPopul,
    "onUpdate:show": _cache[8] || (_cache[8] = $event => $setup.showDetailsPopul = $event),
    class: "popup_coentent",
    overlay: false,
    position: "right"
  }, {
    default: _withCtx(() => [_createElementVNode("div", _hoisted_15, [$setup.detailsView !== 'Login' ? (_openBlock(), _createElementBlock("div", _hoisted_16, [_createVNode(_component_van_icon, {
      size: "22",
      name: "arrow-left",
      onClick: $setup.close
    }, null, 8, ["onClick"]), _createElementVNode("span", _hoisted_17, _toDisplayString($setup.detailsTitle), 1)])) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_18, [(_openBlock(), _createBlock(_resolveDynamicComponent($setup.detailsView), {
      onClose: $setup.close
    }, null, 40, ["onClose"]))])])]),
    _: 1
  }, 8, ["show"]), _createVNode(_component_van_popup, {
    show: $setup.showDialog2,
    "onUpdate:show": _cache[11] || (_cache[11] = $event => $setup.showDialog2 = $event),
    round: ""
  }, {
    default: _withCtx(() => [_createElementVNode("div", _hoisted_19, [_hoisted_20, _hoisted_21, _withDirectives(_createElementVNode("input", {
      "onUpdate:modelValue": _cache[9] || (_cache[9] = $event => $setup.email = $event),
      type: "text",
      "max-length": "36",
      placeholder: "请输入邮箱账号"
    }, null, 512), [[_vModelText, $setup.email]]), _createElementVNode("div", {
      class: "btns",
      onClick: _cache[10] || (_cache[10] = (...args) => $setup.okBtns2 && $setup.okBtns2(...args))
    }, "确认")])]),
    _: 1
  }, 8, ["show"]), _createVNode(_component_van_popup, {
    show: $setup.showDialog3,
    "onUpdate:show": _cache[14] || (_cache[14] = $event => $setup.showDialog3 = $event),
    round: ""
  }, {
    default: _withCtx(() => [_createElementVNode("div", _hoisted_22, [_hoisted_23, _hoisted_24, _withDirectives(_createElementVNode("input", {
      "onUpdate:modelValue": _cache[12] || (_cache[12] = $event => $setup.phone = $event),
      type: "text",
      "max-length": "11",
      placeholder: "请输入手机号号"
    }, null, 512), [[_vModelText, $setup.phone]]), _createElementVNode("div", {
      class: "btns",
      onClick: _cache[13] || (_cache[13] = (...args) => $setup.okBtns3 && $setup.okBtns3(...args))
    }, "确认")])]),
    _: 1
  }, 8, ["show"])]);
}